import { render, staticRenderFns } from "./StaffVacations.vue?vue&type=template&id=1623a4a2&scoped=true&"
import script from "./StaffVacations.vue?vue&type=script&lang=js&"
export * from "./StaffVacations.vue?vue&type=script&lang=js&"
import style0 from "./StaffVacations.vue?vue&type=style&index=0&id=1623a4a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1623a4a2",
  null
  
)

export default component.exports